/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class Apqsv1SystemStat {
    'cpuUsagePercentage'?: number;
    'memoryUsagePercentage'?: number;
    'diskUsagePercentage'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "cpuUsagePercentage",
            "baseName": "cpuUsagePercentage",
            "type": "number",
            "format": "double"
        },
        {
            "name": "memoryUsagePercentage",
            "baseName": "memoryUsagePercentage",
            "type": "number",
            "format": "double"
        },
        {
            "name": "diskUsagePercentage",
            "baseName": "diskUsagePercentage",
            "type": "number",
            "format": "double"
        }    ];

    static getAttributeTypeMap() {
        return Apqsv1SystemStat.attributeTypeMap;
    }

    public constructor() {
    }
}

